import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { SR_API_ACTION_GET_LISTING_LIST } from 'api/actionTypes';

import log from 'client/lib/log';
import branch from 'client/core/branch';
import { SCREEN_ID_SEARCH_FILTERS } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withApiState from 'client/helpers/withApiState';
import withScrollToTop from 'client/helpers/withScrollToTop';
import { Search as SearchActions } from 'client/actions';

import Navbar from 'client/components/Navbar';
import NavbarButton from 'client/components/NavbarButton';
import SrSearchFilterForm from 'client/components/SrSearchFilterForm';

import filterListItems from 'client/helpers/filterListItems';

const debug = log.debug('client:pages:Filter');

@withTransitionHook
@withScreenId(SCREEN_ID_SEARCH_FILTERS)
@withScrollToTop
@withApiState({
  resultsCountApiState: {
    action: SR_API_ACTION_GET_LISTING_LIST,
  },
})
@branch({
  searchFilters: ['search', 'filters'],
  resultsCount: ['search', 'resultsCount'],
  currentUserMarket: ['markets', 'currentUserMarket'],
})
class FilterPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Filter Search | Sunroom Rentals',
    section: 'Onboarding',
    // canonical: '/',
    keywords: 'rent, home, apartment, austin, texas, tour',
    description:
      'Find a safe home in the right location with plenty of natural light! Plus a backyard for your pup 🐶',
  });

  constructor(props) {
    super(props);
    const { match, searchFilters } = props;
    const filterName = match.params.filterName;
    this.state = {
      initialValue: searchFilters[filterName],
    };
  }

  static propTypes = {
    searchFilters: PropTypes.object.isRequired,
    resultsCount: PropTypes.number,
    resultsCountApiState: PropTypes.object.isRequired,
    currentUserMarket: PropTypes.object.isRequired,
  };

  _onChangeFilter = (value) => {
    const { dispatch, match } = this.props;

    const updateFilterApiPayload = {
      filterKey: match.params.filterName,
      filterValue: value,
    };

    debug(`[_onChangeFilter] Value: ${value}`, updateFilterApiPayload);

    dispatch(SearchActions.updateFilter, updateFilterApiPayload);
  };

  _onSubmitFilter = () => {
    const { history } = this.props;
    history.push('/search');
  };

  _onCancelClick = () => {
    const { match, dispatch, history } = this.props;
    const { initialValue } = this.state;

    dispatch(SearchActions.updateFilter, {
      filterKey: match.params.filterName,
      filterValue: initialValue,
    });
    history.push('/search');
  };

  render() {
    const {
      searchFilters,
      match,
      history,
      resultsCount,
      resultsCountApiState,
      currentUserMarket,
    } = this.props;

    if (!filterListItems[match.params.filterName]) {
      return <Redirect to="/search" />;
    }

    const filterData = SearchActions.getSearchFilterSettings({
      searchFilterId: match.params.filterName,
      market: currentUserMarket,
    });

    return (
      <div className="modal specificFilter">
        <div className={filterData.type + ' ' + filterData.id}>
          <div className="modal filters specificFilter">
            <Navbar
              leftButton={<NavbarButton onClick={this._onCancelClick}>Cancel</NavbarButton>}
            />

            <SrSearchFilterForm
              searchFilters={searchFilters}
              onChange={this._onChangeFilter}
              onSubmit={this._onSubmitFilter}
              resultsCount={resultsCount}
              resultsCountIsLoading={resultsCountApiState.inProgress}
              history={history}
              market={currentUserMarket}
              {...filterData}
            />
          </div>
        </div>
      </div>
    );
  }
}

FilterPage.displayName = 'FilterPage';

export default FilterPage;
